import type { OnlineRosterEntry, RecoveryDescriptor } from "./online-room-types.js";

export function recoveryDescriptor(
  roster: readonly OnlineRosterEntry[],
  authorityEpoch: number,
): RecoveryDescriptor {
  const host = roster.find((entry) => entry.role === "host");
  if (!host) throw new TypeError("Recovery roster has no host");
  return Object.freeze({
    authorityEpoch,
    membershipVersion: 1,
    hostMemberId: host.sessionId,
    voters: Object.freeze(roster.map((entry) => entry.sessionId).sort()),
  });
}
